import { render, staticRenderFns } from "./EdicaoCarrinhoDialog.vue?vue&type=template&id=00ef41ea&scoped=true"
import script from "./EdicaoCarrinhoDialog.vue?vue&type=script&lang=js"
export * from "./EdicaoCarrinhoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef41ea",
  null
  
)

export default component.exports